<template>
  <div class="weekplan-weeknote-log text-dark ww" v-if="weeknoteId">
    <button @click="setShowHistory"><span class="icon-clock"></span> {{ $t('vue2.weeknote_log.activity') }}</button>
    <DModal v-if="isShowHistory" :showClose="false" @close="close">
      <div class="ww-modal" slot="insertComponent">
        <div class="ww-modal__header">
          <h2>{{ $t('vue2.weeknote_log.saved_versions') }}</h2>
          <div class="icon__bg-circle ww-modal__header__close" @click="close">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="ww-modal__body">
          <div class="ww-modal__body__sidebar">
            <h3 class="marg-20-bottom text-explainer italic" v-if="logSorted.length === 0">{{ $t('vue2.weeknote_log.no_saved_versions') }}</h3>
            <p class="sidebar__headline" v-else>{{ $t('vue2.weeknote_log.choose_versions_to_compare') }}</p>
            <ul>
              <li v-for="(activity, key) in logSorted"
                  :aria-number="revertedKey(activity)"
                  class="log-list__item"
                  @click="setVersion(activity)"
                  :class="{'log-list__item--active': isInActiveIdx(key)}">
                <div class="log-list__item__header"><div>{{ showHumanizedTime(activity.at) }} {{ $t('vue2.common.ago') }}</div> <div class="pill" v-if="isNewestVersion(activity)">{{ $t('vue2.weeknote_log.current_version') }}</div></div>
                <div>
                  <p><b>{{ showUser(activity.by) }}</b>
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="log-cards">
            <div class="log-cards__card"
                 v-for="(activity, key) in latestActivity">
              <div class="log-cards__card__header">
                <h6>
                  {{ showHumanizedTime(activity.at) }} {{ $t('vue2.common.ago') }}
                  <span class="pill" v-if="isNewestVersion(activity)">{{ $t('vue2.weeknote_log.current_version') }}</span>
                </h6>
                <p><b>{{ showUser(activity.by) }}</b>, {{ showDate(activity.at) }}</p>
              </div>
              <div class="log-cards__card__content" v-html="activity.note">
              </div>
            </div>
          </div>
        </div>
      </div>
    </DModal>
    <div class="bg-overlay" v-if="isShowHistory"></div>
  </div>
</template>
<script>
import DModal from '../common/DModal'
import docendo from '../../docendo'
import moment from 'moment'

export default {
  components: {DModal},
  props: {
    weeknoteId: {}
  },
  data () {
    return {
      activeIdxs: [0, 1],
      log: [],
      isShowHistory: false
    }
  },
  computed: {
    latestActivity () {
      return this.log ? this.log.filter((log, idx) => this.isInActiveIdx(idx)) : []
    },
    logSorted () {
      return this.log ? this.log.sort((a, b) => new Date(b.at) - new Date(a.at)) : []
    }
  },
  methods: {
    showHumanizedTime (dateTime) {
      let diff = moment().diff(moment(dateTime))
      return moment.duration(diff).humanize()
    },
    isInActiveIdx (key) {
      return this.activeIdxs.indexOf(key) > -1
    },
    setShowHistory () {
      this.isShowHistory = true
      this.getWeeknoteLog()
    },
    close () {
      this.isShowHistory = false
    },
    getWeeknoteLog () {
      if (!this.weeknoteId) {
        this.log = []
      }
      docendo.auditWeeknote(window.SCHOOL.id, this.weeknoteId, data => {
        this.log = data && data.length > 0 ? JSON.parse(data) : []
      }, failure => {
        console.log('something went wrong', failure)
      })
    },
    showDate (date) {
      return moment(date).format('L LT')
    },
    showUser (user) {
      return user.name
    },
    revertedKey (version) {
      let idx = this.logSorted.findIndex(log => log.at === version.at)
      return this.logSorted.length - idx
    },
    setVersion (version) {
      let idx = this.logSorted.findIndex(log => log.at === version.at)
      this.activeIdxs = []
      this.activeIdxs.push(idx, idx + 1)
    },
    isNewestVersion (version) {
      let idx = this.logSorted.findIndex(log => log.at === version.at)
      return idx === 0
    }
  }
}
</script>

<style>
@import "../../assets/css/variables.css";

.ww-modal {
  max-width: 80vw;
  overflow: auto;
}

.ww-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
  border-bottom: 1px solid var(--border-color);
}

.ww-modal__header__close {
  font-size: 1.5rem;
}

.ww-modal__body {
  display: flex;
}

.ww-modal__body__sidebar {
  min-width: 300px;
  max-width: 300px;
  padding: 2rem 2rem 2rem 3rem;
  overflow: auto;
  max-height: 80vh;
}

.log-cards {
  padding: 2rem;
  display: flex;
  flex-direction: row-reverse;
  overflow: auto;
  max-height: 80vh;
  align-items: flex-start;
}

.log-cards__card {
  flex: 1;
}

.log-cards__card:last-child {
  margin-right: 2rem;
}

.log-cards__card__header {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.log-cards__card__header h6 {
  font-size: 0.8rem;
  color: gray;
  line-height: 1rem;
  margin-bottom: -1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
}

.pill {
  display: inline-block;
  padding: 2px 4px;
  background: rgb(62 207 142 / 27%);
  color: #3ecf8e;
  border-radius: 2px;
}

.log-cards__card {
  box-shadow: 0 1px 2px rgb(0 0 0 / 7%);
  background: #fff;
  border-radius: 4px;
  padding: 10px;
}

.log-cards__card__content {
  background: #f6f7f8;
  padding: 1rem;
}

.log-list__item {
  position: relative;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  margin-bottom: 0.7rem;
  border-radius: 4px;
  cursor: pointer;
  line-height: 1.2rem;
  transition: background-color 0.1s;
}

.log-list__item:before {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -20px;
  content: attr(aria-number);
  font-weight: bold;
}

.log-list__item:hover, .log-list__item:hover + li {
  background: var(--bg-grey);
}

.log-list__item--active {
  background: #ffffff;
}

.log-list__item__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-explainer {
  font-style: italic;
}

.sidebar__headline {
  color: var(--blue);
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// DoWeekPlanLog.vue?8e073812